import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enTranslation from "./en/translation.json";
import arTranslation from "./ar/translation.json";

// Force language reload when switching
let currentLanguage = localStorage.getItem('i18nextLng') || 'en';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
  resources: {
    en: { translation: enTranslation },
    ar: { translation: arTranslation },
  },
  lng: "en",
  fallbackLng: "en",
  supportedLngs: ["en", "ar"],
  detection: {
    order: ["localStorage", "navigator"],
    caches: ["localStorage"],
  },
  interpolation: {
    escapeValue: false, // React already escapes values
  },
  react: {
    useSuspense: true,
  },
});

export default i18n;